import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Loading from './loading';
export const LoadingSpinner = (props) => {
    return _jsx(_Fragment, { children: _jsx(Loading, { loading: props.loading, loadingContent: _jsx("span", { className: "spinner-border spinner-border-sm me-2", role: "status", "aria-hidden": "true" }), children: props.children }) });
};
export default LoadingSpinner;
